module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido-fdcf906caf0493bd42f74f7943ffdc0a.webp";